export const actionsConstants = {
    SET_DATA: 'STAKE_SET_DATA',
    CLEAR_DATA: 'STAKE_CLEAR_DATA',
};
